/**
 * 앱 전체 라우트 경로의 single source of truth.
 *
 * 새 라우트를 추가하거나 이동 동작(router.push / router.replace / <Link href> /
 * redirectPath / window.location 등)을 구현할 때는 반드시 이 파일에 먼저 정의하고
 * `ROUTES.*` 형태로만 사용한다. 경로 문자열 하드코딩 금지.
 */

type Id = string | number;

export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",

  ACCOUNT: {
    LIST: "/account",
    REGISTER: "/account/register",
    DETAIL: (id: Id) => `/account/${id}`,
    EDIT: (id: Id) => `/account/${id}/edit`,
  },

  CLIENT: {
    LIST: "/client",
    REGISTER: "/client/register",
    DETAIL: (id: Id) => `/client/${id}`,
    EDIT: (id: Id) => `/client/${id}/edit`,
  },

  SITE: {
    LIST: "/site",
    REGISTER: "/site/register",
    DETAIL: (id: Id) => `/site/${id}`,
    EDIT: (id: Id) => `/site/${id}/edit`,
    PARSING: (id: Id) => `/site/${id}/parsing`,
    DRAWING: {
      LIST: (id: Id) => `/site/${id}/drawing`,
      DETAIL: (id: Id, drawingId: Id) => `/site/${id}/drawing/${drawingId}`,
      FLOOR_PLANS: (id: Id, drawingId: Id) =>
        `/site/${id}/drawing/${drawingId}/floor-plans`,
    },
    INSPECTION: {
      LIST: (id: Id) => `/site/${id}/inspection`,
      DETAIL: (id: Id, folderId: Id) => `/site/${id}/inspection/${folderId}`,
    },
  },

  INQUIRY: {
    LIST: "/inquiry",
    DETAIL: (id: Id) => `/inquiry/${id}`,
  }
} as const;
